import replaceCartContent from './replaceCartContent';

// make a web component `gift-wrap` for above feature
if (!customElements.get('gift-wrap')) {
  class GiftWrap extends HTMLElement {
    constructor() {
      super();

      this.checkbox = this.querySelector('input#gift-wrapping');
      if (!this.checkbox) return;

      this.cartDrawer = this.closest('#cart-drawer');
      this.loadingEl = this.cartDrawer.querySelector('.loading');

      this.checkbox.addEventListener('change', this.onGiftWrap.bind(this));
    }

    async onGiftWrap() {
      if (!window.themeSettings.giftWrapProduct.variantId) return;
      if (this.loadingEl) this.loadingEl.setAttribute('loading', '');

      if (this.checkbox.checked) {
        // Check if gift wrap is already in cart
        const giftWrapInCart = await this.giftWrapsInCart();
        if (giftWrapInCart) return;
        await this.toggleGiftWrapToCart(1);
      } else {
        await this.toggleGiftWrapToCart(0);
      }
      if (this.loadingEl) this.loadingEl.removeAttribute('loading');
    }

    async giftWrapsInCart() {
      const cart = await Shopify.functions.getCart();
      if (!cart) return;
      let giftWrapsInCart = false;
      cart.items.forEach((item) => {
        if (item.id == window.themeSettings.giftWrapProduct.variantId) {
          giftWrapsInCart = true;
        }
      });
      return giftWrapsInCart;
    }

    async toggleGiftWrapToCart(quantity) {
      await Shopify.functions.updateCart(window.themeSettings.giftWrapProduct.variantId, quantity);
      await replaceCartContent();
    }
  }
  customElements.define('gift-wrap', GiftWrap);
}
